import NewDivisionAlert from '@/enterprise/components/NewDivisionAlert';
import useTakerMarketsGroups from '@/enterprise/data/useTakerMarketsGroups';
import { OfferModalWithContext } from '@/enterprise/features/offerModal/OfferModalContext';
import QueryBoundaries from '@/shared/components/QueryBoundaries';
import MarketTable from './MarketTable';

const NameYourRateMarketTableComponent = () => {
  const {
    NAME_YOUR_RATE: { takerMarkets },
  } = useTakerMarketsGroups();

  return (
    <div>
      <div className="w-full">
        <NewDivisionAlert takerMarkets={takerMarkets} referrer="customers" className="px-4 pb-6" />
      </div>
      <MarketTable isNameYourRate takerMarkets={takerMarkets} />
    </div>
  );
};

const NameYourRateMarketTable = () => {
  return (
    <QueryBoundaries>
      <OfferModalWithContext>
        <NameYourRateMarketTableComponent />
      </OfferModalWithContext>
    </QueryBoundaries>
  );
};

export default NameYourRateMarketTable;
